import {Injectable} from '@angular/core';

import {Observable, Subscriber} from "rxjs";

import {VehicleService} from "@commons/services/vehicle/vehicle.service";
import {Vehicle} from "@commons/models/domain/Vehicle";

import {NewDriversHttpService} from "@shared/services-http/new-drivers-http.service";
import {NewVehiclesHttpService} from "@shared/services-http/new-vehicles-http.service";
import {NewWebSocketHttpService} from "@shared/websocket/new-web-socket-http.service";
import {BaseService} from "@shared/services/base.service";
import {AuthenticationService} from "@shared/services/authentication/authentication.service";

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService extends BaseService {

  constructor(
    private newDriversService: NewDriversHttpService,
    private newVehiclesService: NewVehiclesHttpService,
    private newWebSocketHttpService: NewWebSocketHttpService,
    private vehicleService: VehicleService,
    private authenticationService: AuthenticationService
  ) {
    super();
  }

  initialize(loadOnlyVehicles: boolean): Observable<boolean> {
    return new Observable<boolean>(observer => {
      this.newVehiclesService.getVehiclesWithIndicators(loadOnlyVehicles).subscribe(
        vehiclesWithIndicators =>
          this.afterVehiclesWithIndicatorsLoaded(
            observer,
            vehiclesWithIndicators,
            loadOnlyVehicles)
      )
    });
  }

  private afterVehiclesWithIndicatorsLoaded(
    observer: Subscriber<boolean>,
    vehicles: Vehicle[],
    loadOnlyVehicles: boolean) {
    this.vehicleService.initDataFlow();

    const isLoggedByLink = this.authenticationService.isLoggedByToken;
    if (loadOnlyVehicles) {
      this.newWebSocketHttpService.start(this.authenticationService.sessionId!, vehicles, [], false, isLoggedByLink);
      observer.next(true);
      observer.complete();
    } else {
      this.newDriversService.get().subscribe((drivers) => {
        this.newWebSocketHttpService.start(this.authenticationService.sessionId!, vehicles, drivers, true, isLoggedByLink);
        observer.next(true);
        observer.complete();
      });
    }
  }

}
